import { NavLink, useLocation } from "react-router-dom";
import { Settings2, Image, ShieldAlert, FileText, PhoneCall, Globe, Wallet, ArrowDownToLine, Megaphone, MessageCircle, Plug, AlignLeft, LayoutDashboard, Smartphone, Send, MessagesSquare, Bot, Wrench } from "lucide-react";

const tabs = [
  { to: "/root/admin/configuration/general", label: "General", icon: Settings2 },
  { to: "/root/admin/configuration/logo", label: "Logo & Icon", icon: Image },
  { to: "/root/admin/configuration/home-content", label: "Home Content", icon: LayoutDashboard },
  { to: "/root/admin/configuration/risk", label: "Risk Management", icon: ShieldAlert },
  { to: "/root/admin/configuration/deposit", label: "Deposit", icon: ArrowDownToLine },
  { to: "/root/admin/configuration/withdraw", label: "Withdraw", icon: Wallet },
  { to: "/root/admin/configuration/announcements", label: "Announcements", icon: Megaphone },
  { to: "/root/admin/configuration/site-notice", label: "Site Notice", icon: Wrench },
  { to: "/root/admin/configuration/footer", label: "Footer", icon: AlignLeft },
  { to: "/root/admin/configuration/ai-chat", label: "AI Live Chat", icon: Bot },
  { to: "/root/admin/configuration/live-chat", label: "Live Chat", icon: MessageCircle },
  { to: "/root/admin/configuration/telegram-support", label: "Telegram Support", icon: MessagesSquare },
  { to: "/root/admin/configuration/dst", label: "DST Gaming API", icon: Plug },
  { to: "/root/admin/configuration/apk", label: "APK Downloads", icon: Smartphone },
  { to: "/root/admin/configuration/telegram", label: "Telegram Bots", icon: Send },
  { to: "/root/admin/configuration/meta", label: "Meta Data", icon: FileText },
  { to: "/root/admin/configuration/contact", label: "Contact", icon: PhoneCall },
  { to: "/root/admin/configuration/social", label: "Social", icon: Globe },
];

export default function ConfigTabs() {
  const { pathname } = useLocation();
  return (
    <div className="bg-white border border-gray-200 rounded-sm mb-6 overflow-x-auto" data-testid="config-tabs">
      <div className="flex items-center min-w-max">
        {tabs.map((t) => {
          const active = pathname === t.to;
          return (
            <NavLink
              key={t.to}
              to={t.to}
              data-testid={`config-tab-${t.label.replace(/\s+/g, "-").toLowerCase()}`}
              className={`inline-flex items-center gap-2 px-5 py-3 text-sm font-medium transition-colors border-b-2 ${active ? "border-emerald-500 text-gray-900 bg-emerald-50/30" : "border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50"}`}
            >
              <t.icon size={15} strokeWidth={1.75} />
              <span>{t.label}</span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
}
